import inView from 'in-view';

inView.offset(100);

inView('.js-inview').on('enter', e => {
  e.classList.add('is-show');
});

inView('.js-inview2').on('enter', e => {
  e.classList.add('is-show2');
});

inView('.js-inview3').on('enter', e => {
  e.classList.add('is-show3');
});

inView('.js-inview4').on('enter', e => {
  e.classList.add('is-show4');
});

inView('.js-inview5').on('enter', e => {
  e.classList.add('is-show5');
});

inView('.js-inview6').on('enter', e => {
  e.classList.add('is-show6');
});

inView('.js-inview7').on('enter', e => {
  e.classList.add('is-show7');
});

inView('.js-inview8').on('enter', e => {
  e.classList.add('is-show8');
});
